export {
  ClientDetailsPage,
  ClientContext,
  ClientDetailsFragment,
} from './Client';
